import { api } from './api';
import { type BayType, BAY_TYPE_LABELS } from './statusTransitionService';

// Re-export for backwards compatibility
export { BAY_TYPE_LABELS };
export type { BayType };

export interface ServiceType {
  id: string;
  name: string;
  nameEn: string | null;
  description: string | null;
  bayType: BayType;
  slotsPerHour: number;
  maintenanceIntervalDays: number | null;
  estimatedDurationMins: number;
  isActive: boolean;
  sortOrder: number;
  createdAt?: number;
  updatedAt?: number;
}

export interface CreateServiceTypeInput {
  name: string;
  nameEn?: string;
  description?: string;
  bayType?: BayType;
  slotsPerHour: number;
  maintenanceIntervalDays?: number | null;
  estimatedDurationMins: number;
  isActive: boolean;
  sortOrder: number;
}

export type UpdateServiceTypeInput = Partial<CreateServiceTypeInput>;

export const serviceTypesApi = {
  list: (includeInactive: boolean = false) => {
    const qs = includeInactive ? '?include_inactive=true' : '';
    return api.get<ServiceType[]>(`/api/service-types${qs}`);
  },

  create: (data: CreateServiceTypeInput) => api.post<ServiceType>('/api/service-types', data),

  update: (id: string, data: UpdateServiceTypeInput) =>
    api.put<ServiceType>(`/api/service-types/${id}`, data),

  delete: (id: string) => api.delete(`/api/service-types/${id}`),
};
